import { render, staticRenderFns } from "./JgpList.vue?vue&type=template&id=5ae458fa&"
import script from "./JgpList.vue?vue&type=script&lang=js&"
export * from "./JgpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports